import { call, put, take } from 'redux-saga/effects';

import { GO_TO_NEXT_PAGE } from './actions';
import { notifications, SET_ISLOADING } from 'PipeRouter';

import { goToNextPage as goNextPage } from 'Services/learnkit';


function* goToNextPage() {
  while (true) {
    yield take(GO_TO_NEXT_PAGE);

    yield put(notifications(SET_ISLOADING, true));
    yield call(goNextPage);
  }
}


export default goToNextPage;
